import { RouteObject } from "react-router";
import { Suspense, lazy } from "react";

import MainLayout from "@/components/layouts";

const Home = lazy(() => import("@/pages/home"));
const MainPage = lazy(() => import("@/pages/room"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <Home />
          </Suspense>
        ),
        handle: { titleKey: "ویزیت انلاین" },
      },
      {
        path: "/:meetId",
        element: (
          <Suspense fallback={null}>
            <MainPage />
          </Suspense>
        ),
        handle: { titleKey: "ویزیت انلاین" },
      },
    ],
  },
];

export default routes;
